import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

import { ViToast, ViToastAction } from './toast';

@Component({
  selector: 'vi-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ViToastComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ViToast,
    public toastRef: MatSnackBarRef<ViToastComponent>,
    private router: Router
  ) {}

  onAction(action: ViToastAction): void {
    if (action.reload) {
      location.reload();
    } else if (action.url) {
      window.open(action.url, '_blank');
    } else if (action.navigateWithReload) {
      window.open(action.navigateWithReload, '_self');
    } else if (action.navigate) {
      this.router.navigate([action.navigate]);
      this.toastRef.dismiss();
    } else {
      this.toastRef.dismiss();
    }
  }

  close(): void {
    this.toastRef.dismiss();
  }
}
